import { Box, TableBody, TableContainer } from '@mui/material';
import { Button } from '@chr/eds-react';
import { useTranslation } from '@chr/online-shared-ui-localizations';

import { StyledTable, StyledTableCell, StyledTableHead, StyledTableRow } from '@/common/components/table';
import { NonPurchaseOrderItem } from '@/common/apis/dtos';

import { NonPoItem } from './NonPoItem';
import { useItemExpand } from '@/common/hooks/useItemExpand';

export interface NonPurchaseOrderItemsProps {
  items: NonPurchaseOrderItem[];
}

export const NonPurchaseOrderItems = ({ items }: NonPurchaseOrderItemsProps) => {
  const translate = useTranslation();
  const [expanded, isAllExpanded, toggleExpand, expandAll, hideAll] = useItemExpand<NonPurchaseOrderItem>(items);

  return (
    <TableContainer>
      <Box sx={{ borderRadius: '4px', border: '1px solid #E5E6E7', overflow: 'auto' }}>
        <StyledTable aria-label="Non-PO Table" data-testid="non-po-cargo-items-table">
          <StyledTableHead>
            <StyledTableRow>
              <StyledTableCell width="200px">{translate('PO#')}</StyledTableCell>
              <StyledTableCell align="left">{translate('Item ID')}</StyledTableCell>
              <StyledTableCell align="left">{translate('SKU')}</StyledTableCell>
              <StyledTableCell width="200px">{translate('Description')}</StyledTableCell>
              <StyledTableCell width="150px" align="right">{translate('Outer Pack Qty')}</StyledTableCell>
              <StyledTableCell align="right">{translate('Weight')}</StyledTableCell>
              <StyledTableCell align="right">{translate('Volume')}</StyledTableCell>
                <StyledTableCell align="left" sx={{ padding: '0px 14px' }} className='no-print'>
                  <Box sx={{ width: 150 }}>
                    <Button
                      startIcon={isAllExpanded ? 'expand_less' : 'expand_more'}
                      onClick={() => (isAllExpanded ? hideAll() : expandAll())}
                      variant={"tertiary"}
                      buttonText={translate(
                        isAllExpanded ? 'Hide All' : 'View All'
                      )}
                    />
                  </Box>
                </StyledTableCell>
            </StyledTableRow>
          </StyledTableHead>

          <TableBody>
            {items.map((item, idx) =>
              <NonPoItem key={`${idx}-${item.commodityItemId}`} item={item} isExpanded={expanded[idx]} onToggleExpand={() => toggleExpand(idx)} />
            )}
          </TableBody>
        </StyledTable>
      </Box>
    </TableContainer>
  );
};
